// Mirrors the Ember `utils/validators/email` regex (ember-validators format),
// so email validation stays consistent across the app as pages migrate over.
const EMAIL_REGEX =
  /^[\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*@(?:[\da-z](?:[\da-z-]*[\da-z])?\.)+[\da-z](?:[\da-z-]*[\da-z])?$/i;

/** Whether `value` is a non-empty, well-formed email address. */
export function isValidEmail(value: string): boolean {
  return value !== '' && EMAIL_REGEX.test(value);
}
